import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import '../styles/DarkModeToggle.scss';

const DarkModeToggle: React.FC = () => {
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);

  return (
    <label className="toggle-switch">
      <input
        type="checkbox"
        checked={darkMode}
        onChange={toggleDarkMode}
        aria-label="Ativar ou desativar modo escuro"
      />
      <span className="slider">
        <span className="toggle-text">
          {darkMode ? (
            'ON'
          ) : (
            <img
              src="/assets/header-moon.webp"
              alt="Ícone modo escuro"
              className="dark-mode-icon"
            />
          )}
        </span>
      </span>
    </label>
  );
};

export default DarkModeToggle;